import { defineMessages } from 'react-intl';

export const personalEventLogMessages = defineMessages({
  room: {
    id: 'PersonalEventLogTab.constants.room',
    defaultMessage: 'Room',
  },
  bed: {
    id: 'PersonalEventLogTab.constants.bed',
    defaultMessage: 'Bed',
  },
  deviceName: {
    id: 'PersonalEventLogTab.constants.deviceName',
    defaultMessage: 'Device',
  },
  event: {
    id: 'PersonalEventLogTab.constants.event',
    defaultMessage: 'Event',
  },
  value: {
    id: 'PersonalEventLogTab.constants.value',
    defaultMessage: 'Value',
  },
  eventStartTime: {
    id: 'PersonalEventLogTab.constants.eventStartTime',
    defaultMessage: 'Event Start Time',
  },
  eventEndTime: {
    id: 'PersonalEventLogTab.constants.eventEndTime',
    defaultMessage: 'Event End Time',
  },
});

export const thresholdMessages = defineMessages({
  highThreshold: {
    id: 'PersonalEventLogTab.constants.highThreshold',
    defaultMessage: 'High',
  },
  lowThreshold: {
    id: 'PersonalEventLogTab.constants.lowThreshold',
    defaultMessage: 'Low',
  },
  vacancyMetric: {
    id: 'PersonalEventLogTab.constants.vacancyMetric',
    defaultMessage: 'Vacancy',
  },
});
